// Shrinks an image in the browser before upload: phone photos arrive at
// 4000px and several MB, the site never shows them wider than ~1200px, and the
// API caps uploads at 3 MB. WebP keeps logo transparency.

const MAX_SIDE = 1600
const QUALITY = 0.86

export async function prepareImage(file: File): Promise<{ blob: Blob; name: string }> {
  if (!/^image\/(png|jpeg|webp)$/.test(file.type)) {
    throw new Error('Choose a PNG, JPEG or WebP image.')
  }
  const bitmap = await createImageBitmap(file)
  const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height))
  const width = Math.round(bitmap.width * scale)
  const height = Math.round(bitmap.height * scale)

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  canvas.getContext('2d')!.drawImage(bitmap, 0, 0, width, height)
  bitmap.close()

  const blob = await new Promise<Blob>((resolve, reject) =>
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Could not encode the image.'))), 'image/webp', QUALITY),
  )
  // Keep the original if re-encoding did not help (already small, or a flat PNG).
  const best = blob.size < file.size || scale < 1 ? blob : file
  const base = file.name.replace(/\.[^.]+$/, '')
  return { blob: best, name: best === blob ? `${base}.webp` : file.name }
}
